import { CommercialDataLadderSearchService } from '../../../epics/fields/commercialData';
import {
    getCommercialBodyTypeKey,
    getCommercialMarkKey,
    getCommercialModelKey,
    getCommercialModificationKey,
    getCommercialTypeKey,
} from './commercialKeys';
import { createCachedServiceThunk } from '../../thunkFactory';

export const getCommercialType = createCachedServiceThunk(
    getCommercialTypeKey,
    () => CommercialDataLadderSearchService.getCommercialType(),
);

export const getCommercialMark = createCachedServiceThunk(
    getCommercialMarkKey,
    (type) => CommercialDataLadderSearchService.getCommercialMark(type),
);

export const getCommercialModel = createCachedServiceThunk(
    getCommercialModelKey,
    (mark) => CommercialDataLadderSearchService.getCommercialModel(mark),
);

export const getCommercialBodyType = createCachedServiceThunk(
    getCommercialBodyTypeKey,
    (params) => CommercialDataLadderSearchService.getCommercialBodyType(params),
);

export const getCommercialCharacteristic = createCachedServiceThunk(
    getCommercialBodyTypeKey,
    (params) =>
        CommercialDataLadderSearchService.getCommercialCharacteristic(params),
);

export const getCommercialTechData = createCachedServiceThunk(
    'commercial/getCommercialTechData',
    (params) => CommercialDataLadderSearchService.getCommercialTechData(params),
);

export const getCommercialModification = createCachedServiceThunk(
    getCommercialModificationKey,
    (params) =>
        CommercialDataLadderSearchService.getCommercialModification(params),
);
